
import TypesPopup from "../../../../../common/AppSpecificConpnents/Types/TypesPopup";


const PreviewPopupTable = ({ type, hidePopup }) => {
  return (
    <>
      <TypesPopup closeTypesModal={hidePopup} useTableInAuditTrail={true}
        auditTrailRow={<>
          <tr>
            <td>{type.name}</td>
            <td>{type.orders}</td>
            <td style={{width:"200px"}}>{type.short_description}</td>
            <td>
              <label>
                <input
                  type="radio"
                  name={`typecheck`}
                  disabled
                  checked={type.is_module}
                  style={{ width: "14px", height: "15px" }}
                />
                <span style={{ marginTop: "5px" }}>Yes</span>
              </label>
            </td>
            <td>
              <label>
                <input
                  type="radio"
                  name={`typecheck`}
                  checked={type.is_procedure}
                  style={{ width: "14px", height: "15px" }}
                  disabled
                />
                <span style={{ marginTop: "5px" }}>Document</span>
              </label>
              <label>
                <input
                  type="radio"
                  name={`typecheck`}
                  checked={type.is_flowchart}
                  disabled
                  style={{ width: "14px", height: "15px" }}
                />
                <span style={{ marginTop: "5px" }}>Document and Flowchart</span>
              </label>
              <label>
                <input
                  type="radio"
                  name={`typecheck`}
                  checked={type.is_allow_record}
                  style={{ width: "14px", height: "15px" }}
                  disabled
                />
                <span style={{ marginTop: "5px" }}>Document with Records</span>
              </label>
            </td>
            <td>
              <label>
                <input
                  type="radio"
                  name={`typecheck`}
                  disabled
                  checked={type.is_record}
                  style={{ width: "14px", height: "15px" }}
                />
                <span style={{ marginTop: "5px" }}>Yes</span>
              </label>
            </td>
            <td>
              <label>
                <input
                  type="radio"
                  name={`typecheck`}
                  disabled
                  checked={type.is_none}
                  style={{ width: "14px", height: "15px" }}
                />
                <span style={{ marginTop: "5px" }}>Yes</span>
              </label>
            </td>
          </tr>
        </>}
      />
    </>
  );
};

export default PreviewPopupTable;
